import { createReducer, on, Action } from '@ngrx/store';
import { remove } from 'lodash';

import { PremiitError } from '../../utils/premiit-error';
import { Reward } from '../../pages/rewards/reward';
import * as rewardsAction from '../actions/rewards.actions';

export interface RewardState {
  data: Reward[];
  selected: Reward;
  loading: boolean;
  error: PremiitError;
}

const rewardInitState: RewardState = {
  data: [],
  selected: null,
  loading: false,
  error: null,
};

const _rewardReducer = createReducer(rewardInitState,
  on(rewardsAction.getRewardsAction, (state: RewardState) => ({ ...state, loading: true })),
  on(rewardsAction.getRewardsSuccessAction, (state: RewardState, { rewards }) => ({
    ...state,
    data: rewards,
    loading: false,
    error: null
  })),
  on(rewardsAction.getRewardsError, (state: RewardState, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(rewardsAction.selectReward, (state: RewardState, { reward }) => ({ ...state, selected: reward })),
  on(rewardsAction.unselectReward, (state: RewardState) => ({ ...state, selected: null })),
  on(rewardsAction.updateRewardAction, (state: RewardState) => ({ ...state, loading: true })),
  on(rewardsAction.updateRewardSuccessAction, (state: RewardState, { reward }) => {
    const rewards: Reward[] = [...state.data];
    const newRewards = rewards.map((storeReward: Reward) => {
      if (storeReward._id === reward._id) {
        return reward;
      }
      return storeReward;
    });
    return {
      ...state,
      data: newRewards,
      loading: false,
      error: null,
      selected: null,
    };
  }),
  on(rewardsAction.updateRewardError, ( state: RewardState, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(rewardsAction.deleteRewardAction, (state: RewardState) => ({ ...state, loading: false })),
  on(rewardsAction.deleteRewardSuccessAction, (state: RewardState, { reward }) => {
    const rewards = [...state.data];
    remove(rewards, (item: Reward) => (item._id === reward._id));
    return { ...state, loading: false, data: rewards, error: null, selected: null };
  }),
  on(rewardsAction.deleteRewardErrorAction, (state: RewardState, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export function RewardsReducer(state: RewardState, action: Action): any {
  return _rewardReducer(state, action);
}
